import { postRequest } from 'utils/request';

export type RollAdminMCPKeyResponse = { key: string };
export const rollAdminMCPKey = (): Promise<RollAdminMCPKeyResponse> =>
  postRequest('/admin/mcp/key');
